import { appendItems, prependItems, withKey, withoutKey } from 'piral-core';
function defaultFilter(_, providerNames) {
    return providerNames;
}
export function createActions(config = {}) {
    const { emptyTrigger = false, filter = defaultFilter } = config;
    return {
        setSearchInput(ctx, input) {
            ctx.dispatch((state) => ({
                ...state,
                search: {
                    ...state.search,
                    input,
                },
            }));
        },
        triggerSearch(ctx, query, immediate = false) {
            const providers = ctx.readState((state) => state.registry.searchProviders);
            const { input, results } = ctx.readState((state) => state.search);
            const { loading } = results;
            if (query === undefined) {
                query = input;
            }
            if (input !== query || !loading) {
                const selectedProviders = filter(query, Object.keys(providers));
                const providerKeys = selectedProviders.filter((m) => !providers[m].onlyImmediate || immediate);
                const acceptQuery = emptyTrigger || !!query;
                const load = acceptQuery && providerKeys.length > 0;
                ctx.resetSearchResults(query, load);
                if (load) {
                    let searchCount = providerKeys.length;
                    let active = true;
                    const opts = {
                        query,
                        immediate,
                    };
                    providerKeys.forEach((key) => {
                        const provider = providers[key];
                        provider.search(opts).then((results) => {
                            active && ctx.appendSearchResults(results, --searchCount === 0);
                        }, (ex) => {
                            console.warn(ex);
                            active && --searchCount === 0 && ctx.appendSearchResults([], true);
                        });
                    });
                    return () => {
                        active = false;
                        providerKeys.forEach((key) => providers[key].cancel());
                        ctx.appendSearchResults([], load);
                    };
                }
                else if (!query) {
                    selectedProviders.forEach((key) => providers[key].clear());
                }
            }
            return () => { };
        },
        resetSearchResults(ctx, input, loading) {
            ctx.dispatch((state) => ({
                ...state,
                search: {
                    input,
                    results: {
                        loading,
                        items: [],
                    },
                },
            }));
        },
        appendSearchResults(ctx, items, done) {
            ctx.dispatch((state) => ({
                ...state,
                search: {
                    ...state.search,
                    results: {
                        loading: !done,
                        items: appendItems(state.search.results.items, items),
                    },
                },
            }));
        },
        prependSearchResults(ctx, items, done) {
            ctx.dispatch((state) => ({
                ...state,
                search: {
                    ...state.search,
                    results: {
                        loading: !done,
                        items: prependItems(state.search.results.items, items),
                    },
                },
            }));
        },
        registerSearchProvider(ctx, name, value) {
            ctx.dispatch((state) => ({
                ...state,
                registry: {
                    ...state.registry,
                    searchProviders: withKey(state.registry.searchProviders, name, value),
                },
            }));
        },
        unregisterSearchProvider(ctx, name) {
            ctx.dispatch((state) => ({
                ...state,
                registry: {
                    ...state.registry,
                    searchProviders: withoutKey(state.registry.searchProviders, name),
                },
            }));
        },
    };
}
//# sourceMappingURL=actions.js.map